<template>
    <div>
        <div>
            <el-row>
                <div class="left-justifying"><h3>公司</h3></div>
                <div class="right-justifying">
                    <el-button type="info" plain size="small" @click="toAdd" v-if="addable">
                        <i class="fa fa-plus-circle">
                        </i> 新建
                    </el-button>
                    <el-button type="info" plain size="small" @click="saveAdd" v-if="saveAddBtnExisted">
                        <i class="fa fa-save">
                        </i> 保存
                    </el-button>
                    <el-button type="info" plain size="small" @click="cancelAdd" v-if="cancelAddBtnExisted">
                        <i class="fa fa-undo">
                        </i> 取消
                    </el-button>
                    <el-button type="info" plain size="small" @click="toEdit" v-if="editBtnExisted">
                        <i class="fa fa-pencil">
                        </i> 修改
                    </el-button>
                    <el-button type="info" plain size="small" @click="saveEdit" v-if="saveEditBtnExisted">
                        <i class="fa fa-save">
                        </i> 保存
                    </el-button>
                    <el-button type="info" plain size="small" @click="cancelEdit" v-if="cancelEditBtnExisted">
                        <i class="fa fa-undo">
                        </i> 取消
                    </el-button>
                    <el-button type="info" plain size="small" @click="toInvalidate" v-if="invalidateBtnExisted">
                        <i class="fa fa-times">
                        </i> 停用
                    </el-button>
                    <el-button type="info" plain size="small" @click="toRevalidate" v-if="revalidateBtnExisted">
                        <i class="fa fa-check">
                        </i> 启用
                    </el-button>
                    <el-button type="info" plain size="small" @click="toRemove" v-if="deleteBtnExisted">
                        <i class="fa fa-times">
                        </i> 删除
                    </el-button>
                </div>
            </el-row>
        </div>
        <div class="panel">
            <div class="panel-body">
                <el-row>
                    <div>
                        <el-tabs v-model="activeTabName" :before-leave="tabsBeforeLeave">
                            <el-tab-pane  v-for="tab in tabs" :key="tab.name" :label="tab.label" :name="tab.name" >
                                <keep-alive>
                                    <router-view :name="tab.name">
                                    </router-view>
                                </keep-alive>
                            </el-tab-pane>
                        </el-tabs>
                    </div>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>

    import {createNamespacedHelpers} from "vuex"

    const companyList = createNamespacedHelpers( "organization/company/list" );
    // const companyDetail = createNamespacedHelpers( "organization/company/detail" );
    const companyForm = createNamespacedHelpers( "organization/company/form" );

    import eventBus from "@/util/common/event-bus";

    export default {
        name: "CompanyMain",
        data() {
            return {
                activeTabName: 'list',
                tabs: [{
                    label: '列表',
                    name: 'list',
                }, {
                    label: '详情',
                    name: 'detail',
                }]
            };
        },
        computed: {
            ...companyList.mapState(['currentRowId']),
            ...companyForm.mapState(['form']),
            addable() {
                return this.activeTabName === 'list';
            },
            saveAddBtnExisted() {
                let path = this.$route.path, operation = this.$route.query.operation, tabName = this.activeTabName;
                return tabName === 'detail' && path === '/organization/company/detail' && (operation == null || operation === 'add');
            },
            editBtnExisted() {
                let path = this.$route.path, operation = this.$route.query.operation, tabName = this.activeTabName;
                return tabName === 'detail' && path === '/organization/company/detail' && (operation === 'show');
            },
            saveEditBtnExisted() {
                let path = this.$route.path, operation = this.$route.query.operation, tabName = this.activeTabName;
                return tabName === 'detail' && path === '/organization/company/detail' && (operation === 'edit');
            },
            cancelAddBtnExisted() {
                let path = this.$route.path, operation = this.$route.query.operation, tabName = this.activeTabName;
                return tabName === 'detail' && path === '/organization/company/detail' && (operation == null || operation === 'add');
            },
            cancelEditBtnExisted() {
                let path = this.$route.path, operation = this.$route.query.operation, tabName = this.activeTabName;
                return tabName === 'detail' && path === '/organization/company/detail' && operation === 'edit';
            },
            invalidateBtnExisted() {
                let path = this.$route.path, operation = this.$route.query.operation, tabName = this.activeTabName;
                let status = this.form.model.status;
                return tabName === 'detail' && path === '/organization/company/detail' && (operation === 'show') && status === '1';
            },
            revalidateBtnExisted() {
                let path = this.$route.path, operation = this.$route.query.operation, tabName = this.activeTabName;
                let status = this.form.model.status;
                return tabName === 'detail' && path === '/organization/company/detail' && (operation === 'show') && status === '0';
            },
            deleteBtnExisted() {
                let path = this.$route.path, operation = this.$route.query.operation, tabName = this.activeTabName;
                return tabName === 'detail' && path === '/organization/company/detail' && (operation === 'show');
            },
        },
        watch: {
            '$route': {
                immediate: true,
                handler() {
                    this.initActiveTabName();
                }
            },
        },
        methods: {
            // ...companyDetail.mapMutations(['setFnCallFlag']),
            initActiveTabName() {
                let path = this.$route.path, tabName = this.activeTabName;
                if (path === '/organization/company/list' && tabName !== 'list') {
                    this.activeTabName = 'list';
                }
                if (path === '/organization/company/detail' && tabName !== 'detail') {
                    this.activeTabName = 'detail';
                }
            },
            tabsBeforeLeave(tabName) {
                let path = this.$route.path;
                if (tabName === 'list' && path !== '/organization/company/list') {
                    this.$router.push('/organization/company/list');
                } else if (tabName === 'detail' && path !== '/organization/company/detail') {
                    this.$router.push({path: '/organization/company/detail', query: {operation: 'show', id: this.currentRowId}});
                }
            },
            toAdd() {
                this.$router.push({path: '/organization/company/detail', query: {operation: 'add'}});
            },
            saveAdd() {
                eventBus.trigger('company_saveAdd');
                // this['setFnCallFlag']({saveAdd: true});
            },
            cancelAdd() {
                this.$router.push('/organization/company/list');
            },
            toEdit() {
                this.$router.push({path: '/organization/company/detail', query: {operation: 'edit', id: this.currentRowId}});
            },
            saveEdit() {
                eventBus.trigger('company_saveEdit');
                // this['setFnCallFlag']({saveEdit: true});
            },
            cancelEdit() {
                this.$router.push({path: '/organization/company/detail', query: {operation: 'show', id: this.currentRowId}});
            },
            toInvalidate() {
                eventBus.trigger('company_invalidate');
                // this['setFnCallFlag']({invalidate: true});
            },
            toRevalidate() {
                eventBus.trigger('company_revalidate');
                // this['setFnCallFlag']({revalidate: true});
            },
            toRemove() {
                eventBus.trigger('company_remove');
                // this['setFnCallFlag']({remove: true});
            },
        },

    }
</script>

<style scoped>

</style>